import flagKeys from '@/constants/flagKeys';
import Activities from '@/views/Performance/Activities.vue';

import { Route } from '../../route.model';

const activities = new Route(
  '/performance/activities',
  'performance-activities',
  Activities,
  {
    requiresAuth: true,
    isResponsive: true,
    flag: flagKeys.merchantDashboardReports,
    zendesk: {
      mobile: {
        offsetHorizontal: '4px',
        offsetVertical: '4px'
      }
    },
    navbar: {
      name: 'Activities',
      icon: 'activities',
      description:
        'Track spending of loyal customers and daily activities of active campaigns.'
    },
    pageView: {
      eventLabel: 'Activity'
    }
  }
);

export { activities };
export default activities;
